<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - Ramnil"
    metaDescription="Connect with premium ad inventory, leverage real-time bidding, and optimize campaigns with data-driven insights. Trusted technology and expert support help you reach the right audience and achieve measurable results.">
    <div class="page-header"></div>
    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">What We Provide for Your Growth</h2>
        <p class="services-section__subtitle">
          We connect you to quality ad inventory and smart optimization tools—helping you scale confidently and maximize every campaign’s return.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="how-it-works-section">
      <div class="how-it-works-section__header">
        <h2 class="how-it-works-section__title">How dose it work ?</h2>
      </div>
      <div class="how-it-works-section__grid">
        <div class="work-step" v-for="(step, index) in workSteps" :key="index">
          <div class="work-step__icon-container">
            <img :src="step.icon" :alt="step.title" class="work-step__icon">
          </div>
          <div class="work-step__content">
            <h3 class="work-step__title">{{ step.title }}</h3>
            <p class="work-step__description">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
  data () {
    return {
      services: [
        {
          title: 'Cross-Channel Campaigns',
          description: 'Run coordinated ads across display, social, video, and mobile channels.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Creative Solutions',
          description: 'Optimize ad creatives with A/B testing, dynamic content, and personalization.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Fraud Protection',
          description: 'Ensure safe ad placements with automated fraud detection and brand safety checks.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Performance Analytics',
          description: 'Track, measure, and report campaign results in real time for data-driven decisions.',
          image: require('@/assets/service-4.png')
        }
      ],
      workSteps: [
        {
          title: 'Sign Up & Verify',
          description: 'Create your account and complete verification to start using the platform.',
          icon: require('@/assets/connect-1.svg')
        },
        {
          title: 'Connect Your Ad Accounts',
          description: 'Link your ad platform accounts for smooth, unified campaign management.',
          icon: require('@/assets/connect-2.svg')
        },
        {
          title: 'Discover Available Inventory',
          description: 'Browse premium ad spaces across multiple channels and select what suits your goals.',
          icon: require('@/assets/connect-3.svg')
        },
        {
          title: 'Place Bids & Execute Trades',
          description: 'Engage in real-time bidding to efficiently secure high-quality ad placements.',
          icon: require('@/assets/connect-4.svg')
        },
        {
          title: 'Launch & Monitor Campaigns',
          description: 'Activate campaigns and track performance with real-time data and insights.',
          icon: require('@/assets/connect-5.svg')
        },
        {
          title: 'Optimize & Scale',
          description: ' Leverage analytics and expert guidance to continuously enhance results and expand reach.',
          icon: require('@/assets/connect-6.svg')
        }
      ]
    };
  }
};
</script>
